module.exports = __webpack_public_path__ + "static/media/slide8.21bcc492.jpg";